import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { OrgInfo, OrgServiceOrgDto, ServicePayload } from '@nx-frontend/shared/types';

export interface UpdateOrgPayload extends ServicePayload {
  globalId: string;
  title?: string;
  sub?: string;
}

export async function getUserOrgs({ host, userId }: ServicePayload) {
  const { data } = await axiosClient.get<OrgServiceOrgDto[]>(`${assertServiceHost(host)}/v1/orgs`, {
    userId,
  });
  return data;
}

export async function updateOrgInternalApi({
  host,
  userId,
  globalId,
  ...restProps
}: UpdateOrgPayload): Promise<OrgServiceOrgDto> {
  const response = await axiosClient.post<OrgServiceOrgDto>(
    `${assertServiceHost(host)}/v1/orgs/${globalId}`,
    restProps,
    {
      userId,
    }
  );
  return response.data;
}

interface GetOrgInfo extends Omit<ServicePayload, 'userId'> {
  orgId: string;
  superSecret: string;
}
export async function getOrgInfo({ host, superSecret, orgId }: GetOrgInfo): Promise<OrgInfo> {
  const response = await axiosClient.get<OrgInfo>(`${assertServiceHost(host)}/v1/orgs/${orgId}/info`, {
    params: {
      newSubscriptionType: 'true',
    },
    secret: superSecret,
  });
  return response.data;
}
